
import anime from 'animejs';
export default class  Animate{
    constructor(element){
        this.graph = document.querySelector('.animate');
        this.graphSquare4 = Array.from(document.querySelectorAll('#_4-riadok rect')); 
        this.graphSquare3 = Array.from(document.querySelectorAll('#_3-riadok rect ')); 
        this.graphSquare2 = Array.from(document.querySelectorAll('#_2-riadok rect')); 
        this.graphSquare1 = Array.from(document.querySelectorAll('#_1-riadok rect')); 
        this.yAxis = document.querySelector('g#yos');
        this.xAxis =document.querySelector('#xos');
        this.yArrow = document.querySelector('#ysipka');
        this.xArrow = document.querySelector('#xsipka');
        this.xAxisPerex= document.querySelector('.maximum-value__xAxis')
        this.yAxisPerex= document.querySelector('.maximum-value__yAxis')
        this.bindEvents();
    }
    bindEvents(){
        document.addEventListener('aos:in:animate-graph', ({ detail }) => {
            this.startAnimatingGraph()
        });
      
     
    }
    
    startAnimatingGraph(){
        let otherSquaresTogether = this.graphSquare3.concat(this.graphSquare2,this.graphSquare1);

        var tl = anime.timeline({
            easing:'easeInOutQuad',
            duration: 500
            
          });
       tl.
       add({
           targets:'#graph-logo',
           opacity:[0,1],
           translateX:[30,0],
           delay:1000,
           endDelay:100,
       }).
        add({
            
            targets: [this.yAxis, this.xAxis,this.yArrow,this.xArrow],
            easing:'linear',
            opacity: [0,1],
            endDelay:100
            
        }).
        add({
            targets:[this.yAxisPerex,this.xAxisPerex],
            easing:'linear',
            opacity:[0,1],
            
            delay:anime.stagger(100),
            endDelay:100,
        }).
       add({
           targets: this.graphSquare4,
           
           visibility:['hidden', 'visible'],
           opacity:[0,1],
           rotate:[1,0],
           duration:70,
           delay:anime.stagger(2)
       }).add({
            targets: otherSquaresTogether,
            easing:'linear',
            visibility:['hidden', 'visible'],
            opacity:[0,1],
            rotate:[1,0],
            duration:180,
            delay:anime.stagger(1)
        
        })
    }
 
}